import { render, staticRenderFns } from "./GangSettings.vue?vue&type=template&id=13dfb4f0&"
import script from "./GangSettings.vue?vue&type=script&lang=js&"
export * from "./GangSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports